import { StyleSheet } from 'react-native';

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  scrollViewContentStyle: withTray => ({
    paddingTop: 32,
    paddingBottom: withTray ? 190 : 100,
    paddingHorizontal: 16,
  }),
  titleStyle: {
    fontSize: 25,
    ...Fonts.type.bold,
  },
  overlayLottie: {
    height: 200,
    width: 200,
  },
  subHeaderDescriptionStyle: { fontSize: 18 },
  subHeaderDescriptionContainerStyle: { marginTop: -5 },
  totalCostTitleStyle: {
    fontSize: 24,
    color: Colors.dark_grey,
    fontFamily: Fonts.type.VodafoneLt,
    fontWeight: '400',
  },
  divider: (theme, marginTop, marginBottom) => ({
    marginTop: marginTop,
    marginBottom: marginBottom,
    height: 1,
    width: '100%',
    backgroundColor: theme.colors.borderColorEight,
  }),
  numberOfUsersContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 16,
  },
  planPerUserPerMonthContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 11,
  },
  totalContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 8,
    marginBottom: 17,
  },
  textStyle: (fontWeight = '700') => ({
    fonFamily: Fonts.type.VFFont,
    fontWeight: fontWeight,
    fontSize: 16,
    color: Colors.dark_grey,
  }),
  totalCostContainerStyle: {
    marginTop: 10,
  },
});
